import React, { useContext, useEffect, useState } from "react";
import { TabContent, TabPane, Nav, Button } from "reactstrap";
import EvolutionInstancesList from "./EvolutionInstancesList";
import ContaSocialCard from "./components/ContaSocialCard";
import FacebookAds from "../FacebookAds";
import Emails from "../Emails";
import { EmailsIntegrados } from "../Emails/EmailsIntegrados";
import api from "../../../../../../services/api";
import "./components/styles.css";
import EmpresaContext from "../../../../../../contexts/Empresa";
import { Portais } from "../Emails/Portais";

export default function ContasSociais() {
  const [activeTab, setActiveTab] = useState("hidden");
  const [fbStatus, setFbStatus] = useState<any>(false);
  const [whatsappConnected, setWhatsappConnected] = useState(false);
  const [malaDiretaEmails, setMalaDiretaEmails] = useState<any>([]);
  const [connectedPages, setConnectedPages] = useState([]);
  const [emailsIntegrados, setEmailsIntegrados] = useState([]);
  const [portaisIntegrados, setPortaisIntegrados] = useState([]);
  const { empresaSelecionada } = useContext(EmpresaContext);

  async function carregarWhatsappStatus() {
    try {
      const { data } = await api.get("/marketing/playnee-conversas/instancias");
      setWhatsappConnected(Array.isArray(data) && data.some((i: any) => i.connected));
    } catch {
      setWhatsappConnected(false);
    }
  }

  const toggle = () => {
    setActiveTab("hidden");
  };

  useEffect(() => {
    carregarWhatsappStatus();
    checkFacebookStatus();
    checkMalaDiretaStatus();
    checkEmailsIntegradosStatus();
    getIntegrations();
  }, []);

  async function checkFacebookStatus() {
    try {
      const response = await api.get("common/canais/facebook");
      const { is_valid, pages } = response.data ?? {};
      setFbStatus(!!is_valid);
      setConnectedPages(pages ?? []);
    } catch (error) {
      console.error(error);
      setFbStatus(false);
    }
  }

  async function checkMalaDiretaStatus() {
    const response = await api.get(
      `common/empresas/${empresaSelecionada?.id}/emails`
    );

    setMalaDiretaEmails(response.data);
  }

  const checkEmailsIntegradosStatus = async () => {
    const response = await api.get(
      `esb/integracoes/ativas?types[]=service&empresaId=${empresaSelecionada?.id}`
    );

    console.log(response);
    setEmailsIntegrados(response.data);
  };

  const getIntegrations = async () => {
    const response = await api.get(
      `esb/integracoes/ativas?&types[]=text&types[]=oauth&types[]=portal&empresaId=${empresaSelecionada?.id}`
    );

    setPortaisIntegrados(response.data);
  };

  return (
    <>
      {activeTab === "hidden" && (
        <Nav role="tablist" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "1.5rem", padding: "1.5rem 0" }}>
          <ContaSocialCard
            isConnected={whatsappConnected}
            icon="fab fa-whatsapp"
            setTabActive={() => setActiveTab("whatsapp-ba")}
            title="WhatsApp"
            type="phone"
          />
          <ContaSocialCard
            isConnected={fbStatus}
            icon="fab fa-facebook"
            name="facebookads"
            setTabActive={() => setActiveTab("facebookads")}
            title="Facebook Ads"
          />
          <ContaSocialCard
            isConnected={malaDiretaEmails.length > 0}
            accounts={malaDiretaEmails}
            icon="fas fa-envelope"
            name="emails-maladireta"
            setTabActive={() => setActiveTab("emails-maladireta")}
            title="Mala Direta Via Emails"
            type="email"
          />
          <ContaSocialCard
            isConnected={emailsIntegrados.length > 0}
            accounts={emailsIntegrados}
            icon="fas fa-envelope"
            name="emails-integrados"
            setTabActive={() => setActiveTab("emails-integrados")}
            title="Emails - Integrações"
            type="email"
          />
          <ContaSocialCard
            isConnected={portaisIntegrados.length > 0}
            accounts={portaisIntegrados}
            icon="fas fa-mail-bulk"
            name="portais-integrados"
            setTabActive={() => setActiveTab("portais-integrados")}
            title="Portais"
            type="portais"
          />
        </Nav>
      )}
      <TabContent activeTab={activeTab}>
        <TabPane tabId="whatsapp-ba">
          <EvolutionInstancesList hideTab={toggle} />
        </TabPane>

        <TabPane tabId="facebookads">
          <Button onClick={toggle}>Voltar</Button>
          <FacebookAds fbStatus={fbStatus} connectedPages={connectedPages} loadPages={checkFacebookStatus} />
        </TabPane>

        <TabPane tabId="emails-maladireta">
          <Button onClick={toggle}>Voltar</Button>
          <Emails />
        </TabPane>

        <TabPane tabId="emails-integrados">
          <Button onClick={toggle}>Voltar</Button>
          <EmailsIntegrados />
        </TabPane>

        <TabPane tabId="portais-integrados">
          <Button onClick={toggle}>Voltar</Button>
          <Portais />
        </TabPane>
      </TabContent>
    </>
  );
}
